import React from 'react';

interface cameraIconProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const CameraIcon = ({ onClick, className }: cameraIconProps) => {
  return (
    <div className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.25 5.8125H17.0625L16.3031 3.68438C16.2507 3.53875 16.1545 3.41288 16.0278 3.32395C15.9011 3.23502 15.7501 3.18736 15.5953 3.1875H8.40469C8.08828 3.1875 7.80469 3.38672 7.69922 3.68438L6.9375 5.8125H3.75C2.71406 5.8125 1.875 6.65156 1.875 7.6875V18.375C1.875 19.4109 2.71406 20.25 3.75 20.25H20.25C21.2859 20.25 22.125 19.4109 22.125 18.375V7.6875C22.125 6.65156 21.2859 5.8125 20.25 5.8125ZM20.4375 18.375C20.4375 18.4781 20.3531 18.5625 20.25 18.5625H3.75C3.64687 18.5625 3.5625 18.4781 3.5625 18.375V7.6875C3.5625 7.58438 3.64687 7.5 3.75 7.5H8.12578L8.52656 6.37969L9.06328 4.875H14.9344L15.4711 6.37969L15.8719 7.5H20.25C20.3531 7.5 20.4375 7.58438 20.4375 7.6875V18.375ZM12 9C9.92812 9 8.25 10.6781 8.25 12.75C8.25 14.8219 9.92812 16.5 12 16.5C14.0719 16.5 15.75 14.8219 15.75 12.75C15.75 10.6781 14.0719 9 12 9ZM12 15C10.7578 15 9.75 13.9922 9.75 12.75C9.75 11.5078 10.7578 10.5 12 10.5C13.2422 10.5 14.25 11.5078 14.25 12.75C14.25 13.9922 13.2422 15 12 15Z"
          fill="#4F4C4C"
        />
      </svg>
    </div>
  );
};

export default CameraIcon;
